module.exports = __webpack_public_path__ + "img/cardBg.763ebad3.png";